export default "__VITE_ASSET__BTo_$Di0__"